function parallaxEffect(className, amount, stopAtZero, isOverlapCheck) {
  const elements = document.querySelectorAll(className);

  elements && window.addEventListener('scroll', function () {
    const scrollPosition = window.pageYOffset;
    if(elements.length > 0){
      elements.forEach((element) => {
        const parentSection = element.closest('.shopify-section');
        if (parentSection) {
          const parentSectionTop = parentSection.getBoundingClientRect().top + scrollPosition;
          const relativeScrollPosition = scrollPosition - parentSectionTop;
          const translateYValue = relativeScrollPosition * amount;
          if (stopAtZero) {
            translateYValue >= 0 ? element.style.transform = `translateY(0px)` : element.style.transform = `translateY(${translateYValue}px)`;
          } else {
           element.style.transform = `translateY(${translateYValue}px)`;
          }
        }
      });
  
      if(isOverlapCheck){
        const overlapPercentage = getOverlapPercentage();
       
        const h2Element = document.querySelector('.image-with-text__text-container h2');
        h2Element ? updateGradientColors(overlapPercentage, h2Element): null;
      }
    }
  });
}

function getOverlapPercentage() {
  let urlGet = document.body.classList.contains('template-lead-lp');
 var h2Element;
  if(urlGet){
       h2Element = document.querySelector('.h2.inverted-text__big-heading')
  }else{
       h2Element = document.querySelector('.image-with-text__text-container h2')  
  }
  const imageElements = document.querySelectorAll('.image-with-text__image-wrapper');
  let imageElement;

  for (let i = 0; i < imageElements.length; i++) {
    if (window.getComputedStyle(imageElements[i]).display !== 'none') {
      imageElement = imageElements[i];
      if(urlGet == false) break;
    }
  }

  if (h2Element && imageElement) {
    const h2Rect = h2Element.getBoundingClientRect();
    const imageRect = imageElement.getBoundingClientRect();
    const overlapTop = Math.max(h2Rect.top, imageRect.top);
    const overlapBottom = Math.min(h2Rect.bottom, imageRect.bottom);
    const overlapHeight = overlapBottom - overlapTop;

    if (overlapHeight > 0) {
      const percentage = (overlapHeight / h2Rect.height) * 100;
      return percentage;
    } else {
      return 0;
    }
  } else {
    return null;
  }
}


function updateGradientColors(overlapPercentage, h2Element) {
  const h2ElementAll = document.querySelectorAll('.image-with-text__text-container h2');
  let urlGet = document.body.classList.contains('template-lead-lp');
  if (h2Element) {
    if (overlapPercentage <= 0) {
      // If there is no overlap, reset the gradient color to black
      h2Element.style.setProperty('--inverted-calc-white', '0%');
      h2Element.style.setProperty('--inverted-calc-black', '-1000%');
    } else {
      const whiteStop = overlapPercentage.toFixed(2) + '%';
      const blackStop = (100 - overlapPercentage).toFixed(2) + '%';
      h2Element.style.setProperty('--inverted-calc-white', whiteStop);
      h2Element.style.setProperty('--inverted-calc-black', `calc(-1000% + ${blackStop})`);
    }
  } else {
    return console.log('h2 element not found');
  }

  if(h2ElementAll.length && urlGet){
   
    if (overlapPercentage <= 0) {
      // If there is no overlap, reset the gradient color to black
      h2Element.style.setProperty('--inverted-calc-white', '0%');
      h2Element.style.setProperty('--inverted-calc-black', '-1000%');
    } else {
      const whiteStop = overlapPercentage.toFixed(2) + '%';
      const blackStop = (100 - overlapPercentage).toFixed(2) + '%';
      h2ElementAll.forEach((ele) => {
        ele.style.setProperty('--inverted-calc-white', whiteStop);
        ele.style.setProperty('--inverted-calc-black', `calc(-1000% + ${blackStop})`);
      })
    }
  }
}

function scrollActiveNavIntoView() {
  const activeNavItem = document.querySelector('.collection__links-item.active');
  if (activeNavItem) {
    const overflowContainer = document.querySelector('.collection__links-list');
    if (overflowContainer) {
      const pseudoElementStyle = window.getComputedStyle(overflowContainer, '::after');
      const content = pseudoElementStyle.getPropertyValue('content');
      if (content === "none") {
        console.log("scroll into view");

        const activeNavItemRect = activeNavItem.getBoundingClientRect();
        const overflowContainerRect = overflowContainer.getBoundingClientRect();
        const offset = (overflowContainer.clientWidth - activeNavItem.clientWidth) / 2;

        const newScrollLeft = activeNavItemRect.left - overflowContainerRect.left + overflowContainer.scrollLeft - offset;
        overflowContainer.scrollTo({
          left: newScrollLeft,
          behavior: 'smooth'
        });
      }
    }
  }
}
 

function removeAllAtcElements(){
  document.querySelectorAll('.quick-atc-container').forEach(function(element) {
    element.setAttribute('data-quick-atc-expanded', 'false');
  });
}

// function closeQuickAtcTrigger(quickAtcDiv){
//   const closeBtn = quickAtcDiv.querySelector('.close-quick-atc');
// closeBtn && quickAtcDiv ? 
// closeBtn.addEventListener('click', () => {
//   removeAllAtcElements();
// }) : null;
// }
function addToCart(dataId) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: dataId,
      quantity: 1
    })
  });
}



const listItems = document.querySelectorAll('.sub_collection_button');
listItems.forEach((item) => {
    item.addEventListener('click', () => {       
        listItems.forEach((li) => {
            li.classList.remove('active');
        });
        item.classList.add('active');
    });
});


// function checkSubmitButtonListeners() {
//   const submitButtons = document.querySelectorAll('button[type="submit"]');

//   submitButtons.forEach(button => {
//     button.addEventListener('click', async event => {
//       event.preventDefault();

//       // Show the loading spinner and disable the button
//       const originalText = button.innerHTML;
//       button.innerHTML = '<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>';
//       button.disabled = true;

//       const select = button.closest('form').querySelector('select');
//       const selectedOption = select.options[select.selectedIndex];

//       if (selectedOption) {
//         const dataId = selectedOption.getAttribute('data-id');
//         try {
//           await addToCart(dataId);
//           // Show the "Added to Cart!" message
//           button.innerHTML = 'Added to Cart!';
//           setTimeout(() => {
//             removeAllAtcElements()
//             setTimeout(()=> {
//               button.innerHTML = originalText;
//               button.disabled = false;
//             }, 500)
//           }, 800);
          
//         } catch (error) {
//           console.error('Error adding product to cart:', error);

//           // Restore the original button text and enable it again
//           button.innerHTML = originalText;
//           button.disabled = false;
//         }
//       } else {
//         console.log('No option is currently selected.');

//         // Restore the original button text and enable it again
//         button.innerHTML = originalText;
//         button.disabled = false;
//       }
//     });
//   });
// }

// function handleQuickAtcTrigger(){
//   const atcTags = document.querySelectorAll('.atc-tag');

//   atcTags && atcTags.forEach(tag => {
//     tag.addEventListener('click', () => {
//       //first, remove all the elements from the DOM
//       removeAllAtcElements();
//       const quickAtcValue = tag.getAttribute('data-quick-atc');
//       if (quickAtcValue) {
//         const quickAtcDiv = document.querySelector(`div[data-quick-atc-id="${quickAtcValue}"]`);
//         if (quickAtcDiv) {
//           // Do something with the found div
//           quickAtcDiv.setAttribute('data-quick-atc-expanded', 'true');
//           checkSubmitButtonListeners();
//           closeQuickAtcTrigger(quickAtcDiv);
//         } else {
//           console.log(`No div found with data-quick-atc-id="${quickAtcValue}"`);
//         }
//         // Do something with the value
//       } else return
//     });
//   });
// }


// Call the parallaxEffect function when the DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  scrollActiveNavIntoView();
  // handleQuickAtcTrigger();
  parallaxEffect('.hero-left', 0.09, false, false);
  parallaxEffect('.hero-middle', 0.12, false, false);
  parallaxEffect('.hero-right', 0.06, false, false);
  parallaxEffect('.image-with-button-image__mobile', -0.04, false, false);
  parallaxEffect('.image-with-button-image__desktop', -0.025, false, false);
  parallaxEffect('.image-with-inverted-text .image-with-text__text-container', .09, true, true);
  // parallaxEffect('.collection__header-image__one', -0.55, false, false);
  // parallaxEffect('.collection__header-image__two', -0.32, false, false);
});



if (document.querySelectorAll('.js-sub_collection_button').length) {
  setTimeout(function(){
    document.querySelector('.js-tooltip').remove();
  },15000);
  document.querySelectorAll('.js-sub_collection_button').forEach(function (element) {
    element.addEventListener('click', function (ele) {
      let dataValue = ele.target.getAttribute('data-value'),
          getInputValue = document.querySelector(`[name="filter.p.m.custom.product_badge"][value="${dataValue}"]`);
      if (getInputValue) {
        if (element.classList.contains('filter-active')) {
          element.classList.remove('filter-active'); // Remove the class
        } else {
          element.classList.add('filter-active'); // Add the class
        }
        
        getInputValue.click();
        
        setTimeout(function () {
          document.querySelector('.filter-drawer__button-apply').click();
        }, 500);
      }
    });
  });
}

{
  const tabsBtn = document.querySelectorAll('.product-description__tabs-btn');

  if(tabsBtn.length){
    tabsBtn.forEach((btn)=>{
      btn.addEventListener('click',()=>{
        let id = btn.getAttribute('data-block-id');
        let tabContentBlocks = btn.parentNode.parentNode.querySelectorAll('.product-description__tabs-content-item');
        let currentBlock = btn.parentNode.parentNode.querySelector(`.product-description__tabs-content-item[data-block-id="${id}"]`);

        tabsBtn.forEach((btn)=>{
          btn.classList.remove('active');
        })

        tabContentBlocks.forEach((block)=>{
          block.classList.remove('open');
        })

        btn.classList.add('active');

        if(currentBlock){
          currentBlock.classList.add('open');
        }
      })
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const shippingSavingPriceContainer = document.querySelector('[js-shipping-saving-price]');
  if (shippingSavingPriceContainer) {
    const savingPriceSpan = shippingSavingPriceContainer.querySelector('span');
    if (savingPriceSpan) {
      savingPriceSpan.innerHTML = shippingSavingPriceContainer.getAttribute('js-shipping-saving-price');
    }
  }
});